module.exports = __webpack_public_path__ + "img/img5.ac609bf8.jpg";